<canvas id="noiseBarChart"></canvas>
